import { createContext, useContext, useState } from "react";

const EditorModeContext = createContext(null);

export function EditorModeProvider({ children }) {
  const [editMode, setEditMode] = useState("design"); 
  // "design" | "preview"

  return (
    <EditorModeContext.Provider value={{ editMode, setEditMode }}>
      {children}
    </EditorModeContext.Provider>
  );
}

export function useEditorMode() {
  return useContext(EditorModeContext);
}